import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../Util/axios_helper";
import { checkPageAccess, sessionUser } from "../Util/common";

const initialState = {
  loading: true,
  user: null,
};

export const getUser = createAsyncThunk("getUser", async (id) => {
  let usr = sessionUser();
  let uId = id;
  if (!uId) {
    uId = localStorage.getItem("UserId");
  }
  if (uId) {
    usr = await fetch("User/GetUser?Id=" + uId);
  }
  if (!usr) {
    return sessionUser();
  }
  return usr;
});

const layoutSlice = createSlice({
  name: "layout",
  initialState: initialState,
  reducers: {
    getUserSession: (state) => {
      let usr = localStorage.getItem("User");
      state.user = usr;
    },
  },
  extraReducers: (builder) => {
    //user
    builder.addCase(getUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getUser.fulfilled, (state, data) => {
      state.loading = false;
      state.user = data.payload;
      if (!(typeof data.payload === "string")) {
        localStorage.setItem("Privillages", data.payload.PrivilegeCodes);
        localStorage.setItem("Username", data.payload.FirstName);
        localStorage.setItem("UserId", data.payload.EmployeeId);
      }
      let result = checkPageAccess(window.location.href.split("/").at(-1));
      if (result) {
        state.loading = false;
      }
    });

    builder.addCase(getUser.rejected, (state, data) => {
      state.loading = true;
      state.user = null;
    });
  },
});

export const { getUserSession } = layoutSlice.actions;
export default layoutSlice.reducer;
